const moduleName: string = "CHAT/";

export const START_SIGNALR: string = `${moduleName}START_SIGNALR`;

export const ADD_MESSAGE_TO_STATE_SUCCESS: string = `${moduleName}ADD_MESSAGE_TO_STATE_SUCCESS`;
export const ADD_MESSAGES_TO_STATE_SUCCESS: string = `${moduleName}ADD_MESSAGES_TO_STATE_SUCCESS`;

export const TRY_GET_PREV_CHAT_START: string = `${moduleName}TRY_GET_PREV_CHAT_START`;
export const TRY_GET_PREV_CHAT_FINISH: string = `${moduleName}TRY_GET_PREV_CHAT_FINISH`;

export const INITIALIZE_MESSAGES_SUCCESS: string = `${moduleName}INITIALIZE_MESSAGES_SUCCESS`;
export const INIT_CLIENT_HIDE_START_MESSAGE_SUCCESS: string = `${moduleName}INIT_CLIENT_HIDE_START_MESSAGE_SUCCESS`;

export const SEND_MESSAGE_ACTION_START: string = `${moduleName}SEND_MESSAGE_ACTION_START`;
export const SEND_MESSAGE_ACTION_SUCCESS: string = `${moduleName}SEND_MESSAGE_ACTION_SUCCESS`;
export const SEND_MESSAGE_ACTION_ERROR: string = `${moduleName}SEND_MESSAGE_ACTION_ERROR`;

export const SEND_FILE_MESSAGE_START_ACTION: string = `${moduleName}SEND_FILE_MESSAGE_START_ACTION`;
export const SEND_FILE_MESSAGE_FINISH_ACTION: string = `${moduleName}SEND_FILE_MESSAGE_FINISH_ACTION`;

export const EDIT_MESSAGE_SUCCESS: string = `${moduleName}EDIT_MESSAGE_SUCCESS`;
export const EDIT_MESSAGE_START: string = `${moduleName}EDIT_MESSAGE_START`;

export const READ_MESSAGE: string = `${moduleName}READ_MESSAGE`;

export const SET_FOOTER_COMPANY_TITLE_SUCCESS: string = `${moduleName}SET_FOOTER_COMPANY_TITLE_SUCCESS`;

export const RESET_CHAT: string = `${moduleName}RESET_CHAT`;